import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'

type ListProps = {
  title: string
  height?: number
  className?: string
}

export const List = ({
  title,
  height = 460,
  children,
  className,
}: PropsWithChildren<ListProps>) => {
  return (
    <div
      className={cn('not-nth-3:border-r not-nth-3:border-gray-100', className)}
    >
      <h2 className="typo-headline2 p-6 font-semibold">{title}</h2>
      <ul
        className="scrollbar thick mb-6 overflow-y-auto overscroll-contain"
        style={{ height }}
      >
        {children}
      </ul>
    </div>
  )
}

type ItemProps = {
  onClick?: () => void
  className?: string
}

export const Item = ({
  className,
  onClick,
  children,
  ...restProps
}: PropsWithChildren<ItemProps>) => {
  return (
    <li>
      <button
        className={cn(
          'typo-body1 flex w-full cursor-pointer items-center justify-between gap-1 px-6 py-3 text-left transition-all',
          'hover:bg-purple-50',
          className,
        )}
        onClick={onClick}
        tabIndex={0}
        {...restProps}
      >
        {children}
      </button>
    </li>
  )
}
